<template>
  <router-view />
</template>

<script setup lang="ts">
import { useQuasar } from 'quasar';

const $q = useQuasar();

// Example of adding support for
// <q-icon name="app:...." />
// This includes support for all "icon" props
// of Quasar components

$q.iconMapFn = (iconName) => {
  // iconName is the content of QIcon "name" prop

  // your custom approach, the following
  // is just an example:
  if (iconName.startsWith('app:') === true) {
    // we strip the "app:" part
    const name = iconName.substring(4);

    return {
      cls: 'icon-' + name,
    };
  }

  // when we don't return anything from our
  // iconMapFn, the default Quasar icon mapping
  // takes over
};
</script>
